<template>
  <div class="auth__login-container">
    <div class="auth__login__content">
      <div class="auth__login__brand-logo">
        <img src="/static/moneywave.png" width="220" height="auto" alt="Moneywave Logo" />
      </div>
      <div class="auth__login-form">
        <form action @submit.prevent="handleForgotPassword()">
          <div class="panel panel--login">
            <div class="panel__header">
              <div class="panel__header__left">
                Login to
                <span>Moneywave</span>
              </div>
              <div class="panel__header__right">
                <router-link
                  :to="{name: 'signup-personal'}"
                  class="btn btn--default"
                >Get a free account</router-link>
              </div>
            </div>
            <div class="panel__content">
              <div id="snackbar"></div>
              <!--email-->
              <div class="auth__login__item">
                <label for="authLoginEmail">
                  Your
                  <span>email</span>
                </label>
                <input
                  id="authLoginEmail"
                  type="email"
                  class="form__input"
                  v-model="email"
                  autocomplete="new-password"
                />
              </div>

              <!--error field-->
              <div class="form__errors" v-if="errorExists" v-for="error in errors">
                <div class="form__errors__icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="22"
                    height="20"
                    viewBox="0 0 22 20"
                  >
                    <defs>
                      <path
                        id="apiicon"
                        d="M10.47 0C4.697 0 0 4.486 0 10s4.697 10 10.47 10c5.773 0 10.47-4.486 10.47-10S16.243 0 10.47 0m0 18c-4.618 0-8.376-3.589-8.376-8s3.758-8 8.376-8c4.619 0 8.376 3.589 8.376 8s-3.757 8-8.376 8m0-13c-.578 0-1.047.447-1.047 1v4c0 .553.47 1 1.047 1 .578 0 1.047-.447 1.047-1V6c0-.553-.469-1-1.047-1m0 8c-.578 0-1.047.447-1.047 1 0 .553.47 1 1.047 1 .578 0 1.047-.447 1.047-1 0-.553-.469-1-1.047-1"
                      />
                    </defs>
                    <use
                      fill="#9C6F19"
                      fill-rule="evenodd"
                      transform="translate(.935)"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      xlink:href="#apiicon"
                    />
                  </svg>
                </div>
                <div class="form__errors__text">{{error}}</div>
              </div>

              <!--submit form-->
              <div class="auth__login__item submit__login-form">
                <button
                  id="loginBtn"
                  type="submit"
                  class="btn btn--primary btn--block"
                >Send Reset Link</button>
              </div>

              <!--forgotpassword-->
              <div class="auth__login__forgot-pass text-center">
                <router-link :to="{name: 'login'}" class="link">
                  Login
                  <span>to Moneywave</span>
                </router-link>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import "./../../assets/stylesheets/scss/auth";
</style>

<script>
import { forgot } from "../../utils/auth/authService";
import { getUser } from "../../utils/user/getUserDetails";
import { mapState } from "vuex";
import { mapGetters } from "vuex";

export default {
  name: "ForgotPassword",
  data() {
    return {
      isLoggedIn: false,
      userPassword: "",
      errors: [],
      errorExists: false,
      email: ""
    };
  },

  computed: {
    getEmail: {
      get() {
        if (this.$store.state.authUser.email === "") {
          return this.$store.state.isUser.email;
        } else {
          return this.$store.state.authUser.email;
        }
      },
      set(value) {
        return this.$store.commit("updateUserEmail", value);
      }
    }
  },

  methods: {
    handleForgotPassword() {
      document.getElementById("loginBtn").disabled = true;
      if (this.email !== "") {
        this.$Progress.start();
        forgot(this.email)
          .then(response => {
            if (response.status === 200) {
              if (response.data.data.notified) {
                if (
                  JSON.parse(response.data.data.notified.m).data.code === "00"
                ) {
                  this.$Progress.finish();
                  this.showSnackbar("If an account with that email address exists, a password reset link has been sent. Please check your email.");
                } else if (
                    JSON.parse(response.data.data.notified.m).data.code !== "00"
                ) {
                    this.$Progress.finish();
                    this.$Progress.fail();
                    this.errorExists = true;
                    this.errors = [];
                    this.errors.push(
                        "There was an error sending the link, please try again"
                    );
                    document.getElementById("loginBtn").disabled = false;
                }
            } else {
                this.$Progress.finish();
                this.showSnackbar("If an account with that email address exists, a password reset link has been sent. Please check your email.");
              }
            }
          })
          .catch(error => {
            console.log(error.message);
            document.getElementById("loginBtn").disabled = false;
            this.$Progress.fail();
            this.errorExists = true;
            this.errors = [];
            this.errors.push(error.response.data.message);
          });
      } else {
        this.$Progress.fail();
        document.getElementById("loginBtn").disabled = false;
        this.errorExists = true;
        let error = "Please provide your email";
        this.errors = [];
        this.errors.push(error);
      }
    },

    handleLogin() {
      document.getElementById("loginBtn").disabled = true;
      let app = this;
      if (this.userPassword !== "" && this.getEmail !== "") {
        //start loader to show progress
        this.$Progress.start();

        //call get login token
        login(this.getEmail, this.userPassword)
          .then(response => {
            // if token is successfully gotten, cache that.
            if (response.status === 200) {
              let token =
                response.data.token_type + " " + response.data.access_token;
                this.$cookies.set("token", token);
              // this.$store.state.commit('updateMerchantList', response);
              app.errorExists = false; //no error then, right?
              this.errors = [];
              //then get user details
              this.getUserDetails();
            } else {
              document.getElementById("loginBtn").disabled = false;
            }
          })

          //catch error from the login API and do something about the errors
          .catch(error => {
            document.getElementById("loginBtn").disabled = false;
            this.$Progress.fail();
            this.errorExists = true;
            this.errors = [];
            this.errors.push(error.response.data.error_description);
            console.log(this.errors);
            console.log(error);
          });
      }

      //on frontend, if email and password isn't provided
      else {
        this.$Progress.fail();
        this.errorExists = true;
        let error = "Please provide your email and password";
        this.errors = [];
        this.errors.push(error);
      }
    },
    showSnackbar(text) {
      let snackbar = document.getElementById("snackbar");
      snackbar.innerHTML = text;
      snackbar.className = "show";

      setTimeout(function() {
        snackbar.className = snackbar.className.replace("show", "");
      }, 10000);
    }
  }
};
</script>
<style scoped>
#snackbar {
  visibility: hidden;
  /*poisition: fixed;*/
  top: 0px;
  background-color: deepskyblue;
  color: white;
  padding: 5px;
  text-align: center;
}

#snackbar.show {
  visibility: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/auth/forgotPasswordPage.vue